import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h32v32H0z" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "m5.215 7.545 5.073 4.329 4.52-5.397c.127-.15.287-.272.468-.355a1.37 1.37 0 0 1 1.159.013q.272.131.46.364l4.313 5.373 5.237-4.39a1.37 1.37 0 0 1 1.512-.155c.238.126.43.32.552.556s.166.502.127.762l-2 13.378H5.046L3.014 8.706c-.04-.262.003-.53.125-.767s.316-.433.556-.56a1.37 1.37 0 0 1 1.519.166m-.066 15.771h21.334v1.293c0 .343-.14.672-.39.914-.251.243-.59.379-.944.379H6.483c-.354 0-.693-.136-.943-.379a1.27 1.27 0 0 1-.39-.914z"
    }
  ))
);
var SvgCrownFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CrownFilled_default = SvgCrownFilled;

export { CrownFilled_default as default };
